import { Icon as BlueIcon } from '@blueprintjs/core';

import { useRef, useState } from 'react';

import { GlobalOverlay } from '@components';

import { IStudioFilterResultRequests, IStudios } from '@models/Studios.model';
import {
  Close,
  Header,
  IconButton,
  Menu,
  MenuListItem,
  Title,
  Wrapper,
} from './Filter.styles';
import { FilterItem } from './components/FilterItem/FilterItem';

interface IFilterRaw {
  studios?: IStudioFilterResultRequests<IStudios>;
}

export const FilterRaw = ({ studios }: IFilterRaw) => {
  const ref = useRef(null);

  const [open, setOpen] = useState<boolean>(false);

  return (
    <Wrapper>
      <IconButton
        ref={ref}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <BlueIcon icon="filter" color="#8F95B2" />
      </IconButton>
      {open && <GlobalOverlay />}

      <Menu align="end" anchorRef={ref} state={open ? 'open' : 'closed'}>
        <Header>
          <Title>Filter</Title>
          <Close
            onClick={() => {
              setOpen(false);
            }}
          >
            <BlueIcon icon="cross" color="#8F95B2" />
          </Close>
        </Header>

        <MenuListItem>
          <FilterItem
            item_text="Studio"
            item_searched_data={studios?.assets}
            onClickItem={() => setOpen(false)}
          />
        </MenuListItem>
      </Menu>
    </Wrapper>
  );
};
